<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <b-card
            no-body
            class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
          >
            <b-navbar toggleable="lg">
              <b-navbar-brand
                href="#"
                class="text-dark"
              >
                <strong style="color:#3b3e66">Platform</strong>
              </b-navbar-brand>

              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button
                    @click="showAddPlatformModal = !showAddPlatformModal"
                    class="mr-2"
                    variant="outline-primary"
                    size="sm"
                  >
                  Add New Platform Setting
                    <!-- <font-awesome-icon icon="plus" /> -->
                  </b-button>
                  <b-button
                    variant="outline-info"
                    size="sm"
                    class="mr-4"
                    @click="reloadTable"
                  >
                  Reload
                    <!-- <font-awesome-icon icon="sync" /> -->
                  </b-button>
                  <b-form-group>
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          :disabled="!filter"
                          @click="filter = ''"
                        >Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>
            <b-table
              sticky-header="calc(100vh - 295px)"
              :busy.sync="isLoading"
              bordered
              hover
              striped
              ref="table"
              id="platform-table"
              :fields="staticFields"
              :items="platformItems"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              no-sort-reset
            >
              <template v-slot:cell(actions)="data">
                <b-btn
                  @click="editPlatform(data)"
                  class="mr-2"
                  size="sm"
                  variant="outline-info"
                >
                Edit
                  <!-- <font-awesome-icon icon="edit" /> -->
                </b-btn>
              </template>
            </b-table>

            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Showing Result From
                    <b>{{fromRows}}</b> to
                    <b>{{toRows}}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="platform-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      :title="isEditPlatform ? 'Update Platform' : 'Add New Platform Setting'"
      size="lg"
      scrollable
      v-model="showAddPlatformModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-row>
            <b-col cols="6">
              <b-form-group style="margin-top: 20px;">
                <label class="text-left">Platform Variable Name:</label>
                <b-form-input
                  v-model="$v.form.platformVariableName.$model"
                  :state="$v.form.platformVariableName.$dirty ? !$v.form.platformVariableName.$error : null"
                  size="sm"
                  type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group style="margin-top: 20px;">
                <label class="text-left">Platform Variable Key:</label>
                <b-form-input
                  v-model="$v.form.platformVariableKey.$model"
                  :state="$v.form.platformVariableKey.$dirty ? !$v.form.platformVariableKey.$error : null"
                  size="sm"
                  type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group style="margin-top: 20px;">
                <label class="text-left">Platform Variable Value:</label>
                <b-form-input
                  v-model="$v.form.platformVariableValue.$model"
                  :state="$v.form.platformVariableValue.$dirty ? !$v.form.platformVariableValue.$error : null"
                  size="sm"
                  type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{ isEditPlatform ? 'Your Platform is being Updateing......' : 'Your Platform is being Creating......' }}</p>
          <b-spinner
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ isEditPlatform ? 'Your Platform has been updated successfully.' : 'Your Platform has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          v-if="!submiting"
          @click="resetModal"
          variant="outline-danger"
        >Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >{{ isEditPlatform ? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
import { Helper } from "../../../helpers";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "PlatformsSetting",
  mixins: [validationMixin],
  data () {
    return {
      isEditPlatform: false,
      tableItemsIndex: null,
      submiting: false,
      isLoading: false,
      responseSuccess: false,
      showAddPlatformModal: false,
      totalRows: 0,
      filter: null,
      perPage: 10,
      toRows: 0,
      fromRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "platform_variable_name", label: "Platform Variable Name", sortable: true },
        { key: "platform_variable_key", label: "Platform Variable Key", sortable: true },
        { key: "platform_variable_value", label: "Platform Variable Value", sortable: true },
        { key: "actions", label: "Action", sortable: false },
      ],
      platformItems: [],
      form: {
        platformVariableName: null,
        platformVariableKey: null,
        platformVariableValue: null
      },
      platformId: null,
    };
  },
  validations: {
    form: {
      platformVariableName: { required },
      platformVariableKey: { required },
      platformVariableValue: { required },
    },
  },
  computed: {
    rows () {
      return this.platformItems.length;
    },
  },
  mounted () {
    this.getPlatformData();
  },
  methods: {
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    reloadTable () {
      this.getPlatformData();
    },
    async getPlatformData () {
      this.platformItems = [];
      this.platformId = null;
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let result = HTTP( "post", "api/v1/platform/get", formData );

      return result
        .then( ( response ) => {
          this.platformId = response.data.id ? response.data.id : null;
          let data = JSON.parse( response.data.platform_variables )
          this.platformItems = data;
          this.isLoading = false;
        } )
        .catch( ( error ) => {
          this.isLoading = false;
          return [error];
        } );
    },
    resetForm () {
      this.form = {
        platformVariableName: null,
        platformVariableKey: null,
        platformVariableValue: null
      };
    },
    resetModal () {
      this.resetForm();
      this.isEditPlatform = false;
      this.tableItemsIndex = null;
      this.showAddPlatformModal = false;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    checkValidation () {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else if ( this.isEditPlatform ) {
        this.updatePlatformSettingCall();
      } else {
        this.savePlatformSettingCall();
      }
    },
    savePlatformSettingCall () {
      if ( this.platformId == null ) {
        this.savePlatformSetting( "api/v1/platform/create" ).then( this.reloadTable );
      } else {
        let url = "api/v1/platform/add/new/row/" + this.platformId;
        this.savePlatformSetting( url ).then( this.reloadTable );
      }
    },
    async savePlatformSetting ( url ) {
      let formData = {
        platform_variables: {
          platform_variable_name: this.form.platformVariableName,
          platform_variable_key: this.form.platformVariableKey,
          platform_variable_value: this.form.platformVariableValue
        },
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP( "post", url, formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        if ( result.data.status == 1 ) {
          this.makeToster( "success", result.data.message );
        } else {
          this.makeToster( "danger", result.data.message );
        }
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async updatePlatformSetting () {
      let formData = {
        platform_variables: this.platformItems,
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "put",
          "api/v1/platform/" + this.platformId,
          formData
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        if ( result.data.status == 1 ) {
          this.makeToster( "success", result.data.message );
        } else {
          this.makeToster( "danger", result.data.message );
        }
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    updatePlatformSettingCall () {
      this.platformItems[this.tableItemsIndex].platform_variable_name = this.form.platformVariableName;
      this.platformItems[this.tableItemsIndex].platform_variable_key = this.form.platformVariableKey;
      this.platformItems[this.tableItemsIndex].platform_variable_value = this.form.platformVariableValue;
      this.updatePlatformSetting().then( this.reloadTable );
    },
    editPlatform ( data ) {
      this.isEditPlatform = true;
      this.tableItemsIndex = data.index;
      this.form = {
        platformVariableName: data.item.platform_variable_name,
        platformVariableKey: data.item.platform_variable_key,
        platformVariableValue: data.item.platform_variable_value
      }
      this.showAddPlatformModal = true;
    },
    makeToster ( tosterVarient, tosterMsg ) {
      this.resetModal();
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },
  },
};
</script>
<style scoped>
@import "../../../assets/styles/theme1/tabs.css";
@import "../../../assets/styles/theme1/timeline.css";
/* @import "../../../assets/styles/theme1/card.css"; */
@import "../../../assets/styles/theme1/badge.css";
</style>

<style>
.table-hover tbody tr:hover td {
  background-color: rgb(255, 251, 242) !important;
}
</style>